import { Grid, Text, Tooltip } from '@mantine/core';
import { UseQueryResult } from '@tanstack/react-query';
import * as React from 'react';
import { ControlledInputs } from '../../../../../react-commons/utils/read-only-inputs/controlledInputs';
import { UserResource } from '../../../resource/resources/persistables/user/userResource';
import { Show } from '../../../../../react-commons/components/control-flow/Show';
import { Group } from '@visx/group';

export const MetaDataInfoContent= ({ metaDataInfo, createdAt, createdBy, lastUpdatedAt, lastUpdatedBy }: {
    metaDataInfo?: {
        id: string;
        objectId: string;
    };
    createdAt: Date | undefined;
    createdBy: UseQueryResult<UserResource | null>;
    lastUpdatedAt: Date | undefined;
    lastUpdatedBy: UseQueryResult<UserResource | null>;
}) => {

    const getLastUpdatedBy = () => lastUpdatedBy.data ?? createdBy.data

    return (
        <Grid>
            {metaDataInfo && (
                <>
                    <Grid.Col span={6}>
                        <div style={{ display: 'inline-flex', width: '100%', alignItems: 'center' }}>
                            <Text style={{ minWidth: 130 }}>ID</Text>
                            <ControlledInputs.String
                                nullable={false}
                                readOnly={true}
                                style={{ flexGrow: 1 }}
                                value={metaDataInfo.id}
                            />
                        </div>
                    </Grid.Col>
                    <Grid.Col span={6}>
                        <div style={{ display: 'inline-flex', width: '100%', alignItems: 'center' }}>
                            <Text style={{ minWidth: 130 }}>Object ID</Text>
                            <ControlledInputs.String
                                nullable={false}
                                readOnly={true}
                                style={{ flexGrow: 1 }}
                                value={metaDataInfo.objectId}
                            />
                        </div>
                    </Grid.Col>
                </>
            )}
            <Grid.Col span={6}>
                <div style={{ display: 'inline-flex', width: '100%', alignItems: 'center' }}>
                    <Text style={{ minWidth: 130 }}>Created At</Text>
                    <ControlledInputs.String
                        nullable={false}
                        readOnly={true}
                        style={{ flexGrow: 1 }}
                        value={createdAt?.toLocaleString() ?? ''}
                    />
                </div>
            </Grid.Col>
            <Grid.Col span={6}>
                <Tooltip
                    withArrow
                    arrowSize={8}
                    arrowOffset={15}
                    position={"bottom-end"}
                    label={ createdBy.data?.userDetails ?
                        <div style={{display: 'flex', width: '100%', flexDirection: 'column'}}>
                            <Show when={createdBy.data?.userDetails?.name}>
                                <Group style={{textAlign: "right"}}>
                                    <Text c={'var(--mantine-text-reverse-secondary-color)'} w={100}>Name:</Text>
                                    <Text c={'var(--mantine-text-reverse-secondary-color)'}>{createdBy.data?.userDetails?.name ?? ""}</Text>
                                </Group>
                            </Show>
                            <Group style={{textAlign: "right"}}>
                                <Text c={'var(--mantine-text-reverse-secondary-color)'} w={100}>User Name:</Text>
                                <Text c={'var(--mantine-text-reverse-secondary-color)'}>{createdBy.data?.userName ?? ""}</Text>
                            </Group>
                            <Show when={createdBy.data?.userDetails?.email}>
                                <Group style={{textAlign: "right"}}>
                                    <Text c={'var(--mantine-text-reverse-secondary-color)'} w={100}>Email:</Text>
                                    <Text c={'var(--mantine-text-reverse-secondary-color)'}>{createdBy.data?.userDetails?.email ?? ""}</Text>
                                </Group>
                            </Show>
                        </div>
                        : undefined
                    }
                >
                    <div style={{ display: 'inline-flex', width: '100%', alignItems: 'center' }}>
                        <Text style={{ minWidth: 130 }}>Created By</Text>
                        <ControlledInputs.String
                            nullable={false}
                            readOnly={true}
                            style={{ flexGrow: 1 }}
                            value={createdBy.data?.userDetails?.name ? `${createdBy.data?.userDetails?.name} (${createdBy.data?.userName})` : createdBy.data?.userName ?? ''}
                        />
                    </div>
                </Tooltip>
            </Grid.Col>
            <Grid.Col span={6}>
                <div style={{ display: 'inline-flex', width: '100%', alignItems: 'center' }}>
                    <Text style={{ minWidth: 130 }}>Last Updated At</Text>
                    <ControlledInputs.String
                        nullable={false}
                        readOnly={true}
                        style={{ flexGrow: 1 }}
                        value={lastUpdatedAt?.toLocaleString() ?? ''}
                    />
                </div>
            </Grid.Col>
            <Grid.Col span={6}>
                <Tooltip
                    withArrow
                    arrowSize={8}
                    arrowOffset={15}
                    position={"bottom-end"}
                    label={ getLastUpdatedBy()?.userDetails ?
                        <div style={{display: 'flex', width: '100%', flexDirection: 'column'}}>
                            <Show when={getLastUpdatedBy()?.userDetails?.name}>
                                <Group style={{textAlign: "right"}}>
                                    <Text c={'var(--mantine-text-reverse-secondary-color)'} w={100}>Name:</Text>
                                    <Text c={'var(--mantine-text-reverse-secondary-color)'}>{getLastUpdatedBy()?.userDetails?.name ?? ""}</Text>
                                </Group>
                            </Show>
                            <Group style={{textAlign: "right"}}>
                                <Text c={'var(--mantine-text-reverse-secondary-color)'} w={100}>User Name:</Text>
                                <Text c={'var(--mantine-text-reverse-secondary-color)'}>{getLastUpdatedBy()?.userName ?? ""}</Text>
                            </Group>
                            <Show when={getLastUpdatedBy()?.userDetails?.email}>
                                <Group style={{textAlign: "right"}}>
                                    <Text c={'var(--mantine-text-reverse-secondary-color)'} w={100}>Email:</Text>
                                    <Text c={'var(--mantine-text-reverse-secondary-color)'}>{getLastUpdatedBy()?.userDetails?.email ?? ""}</Text>
                                </Group>
                            </Show>
                        </div>
                        : undefined
                    }
                >
                    <div style={{ display: 'inline-flex', width: '100%', alignItems: 'center' }}>
                        <Text style={{ minWidth: 130 }}>Last Updated By</Text>
                        <ControlledInputs.String
                            nullable={false}
                            readOnly={true}
                            style={{ flexGrow: 1 }}
                            value={getLastUpdatedBy()?.userDetails?.name ? `${getLastUpdatedBy()?.userDetails?.name} (${getLastUpdatedBy()?.userName})` : getLastUpdatedBy()?.userName ?? ''}
                        />
                    </div>
                </Tooltip>
            </Grid.Col>
        </Grid>
    );
};
